<template>
  <div class="secur-ity m-consumption Real-name">
    <template v-if="vip_level >= 0">
      <p v-show="active" class="yshiming">您已通过实名认证！</p>
      <div v-show="!active">
        <div class="u-toptilte">
          <p><i style="color: #ffcc00">▎</i>实名认证</p>
        </div>
        <div class="form alg real-form-content" v-if="showStatus">
          <div class="title">一、请填写真实的个人信息开始认证</div>
          <el-form label-width="120px" class="real-box">
            <el-row type="flex" justify="center" class="informationForm-row">
              <el-col :xs="24" :sm="18" :md="12">
                <el-form-item label="真实姓名：">
                  <el-input
                    @blur="checkname"
                    v-model="informationForm.name"
                  ></el-input>
                  <div class="el-form-item__error">{{ cuowuspan.name }}</div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row type="flex" justify="center" class="informationForm-row">
              <el-col :xs="24" :sm="18" :md="12">
                <el-form-item label="身份证号：">
                  <el-input
                    @blur="checkidcard"
                    v-model="informationForm.idcard"
                  ></el-input>
                  <div class="el-form-item__error">{{ cuowuspan.idcard }}</div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item>
              <section class="btn1">
                <a @click="real1" class="u-btnzx">开始实名认证</a>
              </section>
            </el-form-item>
          </el-form>
        </div>
        <div class="code-content" v-if="!showStatus">
          <div class="title">
            二、请用手机打开<img
              src="../assets/images/alipay32.png"
              alt=""
            /><span>支付宝app</span>扫码完成实名认证
          </div>
          <div class="box">
            <div class="codeImg" ref="qrcode"></div>
            <div class="tip">
              <img src="../assets/images/saoyisao.png" alt="" />
              <div class="text">打开支付宝扫一扫完成实名认证</div>
            </div>
          </div>
          <div class="reminder">
            * 有效时间5分钟，请在有效时间内进行扫码认证
          </div>
        </div>
      </div>
    </template>
    <p v-else class="active">用户可以进行实名认证，实名认证成功赠送6海星点。</p>
  </div>
</template>

<script>
import QRCode from 'qrcodejs2'
export default {
  name: 'ComUpLoad',
  data () {
    return {
      active: false,
      showStatus: true, // 显示步骤 true显示第一步；false显示第二步
      // 输入的数据
      informationForm: {
        name: '',
        idcard: ''
      },
      // 错误的提示信息
      cuowuspan: {
        name: '',
        idcard: ''
      },
      // 标识符
      name: false,
      idcard: false,
      vip_level: '',
      certify_id: '',
      timer: null, // 定时器名称
      timerNum: 150 // 设置定时器时间(时间走完清除定时器) 2秒轮询一次
    }
  },
  mounted () {
    this.http.gerenzx().then(res => {
      this.informationForm.name = res.data.data.full_name
      this.informationForm.idcard = res.data.data.id_card
      this.vip_level = res.data.data.vip_level
      this.active = res.data.data.active
    })
  },
  methods: {
    checkname () {
      if (this.informationForm.name === '') {
        this.cuowuspan.name = '请输入真实姓名'
        this.name = true
        return false
      } else {
        this.cuowuspan.name = ''
        this.name = false
      }
    },
    checkidcard () {
      if (this.informationForm.idcard === '') {
        this.idcard = false
        this.cuowuspan.idcard = '请填写身份证号码'
      } else if (this.informationForm.idcard !== '') {
        this.idcard = false
        this.cuowuspan.idcard = ''
        var card = this.$cookieStore.checkID(this.informationForm.idcard)
        if (card === '0') {
          this.idcard = false
          this.cuowuspan.idcard = '身份证号码有误'
          return false
        } else if (this.informationForm.idcard.length === 18) {
          this.http.yzidcard(this.informationForm.idcard).then(res => {
            if (res.data.code === 200) {
              if (res.data.message === 'true') {
                this.idcard = false
                this.cuowuspan.idcard = '该身份证号码已被注册'
              } else {
                this.idcard = true
                this.cuowuspan.idcard = ''
              }
            }
          })
        } else {
          this.idcard = false
          this.cuowuspan.idcard = ''
        }
      }
    },
    // 生成二维码
    creatQrcode (url) {
      this.$refs.qrcode.innerHTML = ''
      let qrcodeObj = this.$refs.qrcode
      let qrcode = new QRCode(qrcodeObj, {
        text: encodeURI(url),
        width: 250,
        height: 250,
        correctLevel: QRCode.CorrectLevel.L // 降低容错级别
      })
      qrcode.clear() // 清除二维码
      qrcode.makeCode(url)// 生成另一个新的二维码
    },
    real1 () {
      setTimeout(() => {
        this.real()
      }, 200)
    },
    // 实名认证
    real () {
      if (this.informationForm.name === '') {
        this.$message.error('请填写姓名！')
        return
      }
      if (this.informationForm.idcard === '') {
        this.$message.error('请填写正确的身份证号！')
        return
      }
      if (!this.idcard) {
        this.$message.error('请填写正确的身份证号！')
        return
      }
      this.http.alipay_certify(this.informationForm.name, this.informationForm.idcard).then(res => {
        if (res.data.code === 200) {
          setTimeout(() => {
            this.creatQrcode(decodeURIComponent(res.data.data.url))
          }, 100)
          this.certify_id = res.data.data.certify_id
          this.showStatus = false
          this.queryCertify()
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    // 查询实名认证结果
    queryCertify () {
      this.timerNum = 150
      this.clearTimer()
      this.timer = setInterval(() => {
        setTimeout(() => {
          if (this.timerNum === 0) {
            this.timer && this.clearTimer() // 关闭定时器
            setTimeout(() => { this.$router.go(0) }, 2000)
          } else {
            this.timerNum -= 1 // 定时器减1
            if (this.certify_id) {
              this.http.certify_query(this.certify_id).then(res => {
                if (res.data.code === 200) {
                  this.clearTimer()
                  this.$message.success('实名认证成功')
                  setTimeout(() => { this.$router.go(0) }, 3000)
                } else if (res.data.code === 500) {
                  this.clearTimer()
                  this.$message.error(res.data.message)
                  setTimeout(() => { this.$router.go(0) }, 2000)
                }
              })
            }
          }
        }, 0)
      }, 2000)
    },
    // 清除定时器
    clearTimer () {
      clearInterval(this.timer)
      this.timer = null
    }
  },
  destroyed () {
    clearInterval(this.timer)
    this.timer = null
  }
}
</script>
<style   lang="scss">
.real-form-content {
  width: 100% !important;
  margin: 0 !important;
  .title {
    font-size: 16px;
  }
  .real-box {
    margin: 60px 0 0 0;
    .el-form-item__error {
      top: 90%;
    }
    .btn1 {
      text-align: center;
      padding-top: 35px;
      font-size: 16px;
      a {
        height: 40px;
        line-height: 40px;
      }
    }
  }
}
.code-content {
  .title {
    font-size: 16px;
    img {
      width: 22px;
      height: 22px;
      vertical-align: text-bottom;
    }
    span {
      color: antiquewhite;
    }
  }
  .box {
    position: relative;
    margin: 20px auto;
    width: 280px;
    height: 354px;
    border: 1px solid #909399;
    background: #fff;
    box-shadow: 0 0 10px rgba($color: #909399, $alpha: 1);
    .codeImg {
      width: 250px;
      height: 250px;
      margin: 20px auto;
    }
    .tip {
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 66px;
      background: #182133;
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      img {
        width: 48px;
        height: 48px;
      }
      .text {
        width: 140px;
      }
    }
  }
  .reminder {
    font-size: 16px;
    color: antiquewhite;
    text-align: center;
  }
}
@media screen and(max-width: 500px) {
  .alg {
    min-height: 1140px !important;
  }
}
@media screen and(min-width: 768px) {
  .real-form-content {
    .real-box {
      margin: 60px 0 0 -100px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Real_name.vue